import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Dashheader from '../Dashheader/Dashheader';
import utilis from './../../../utilis';
import api from './../../../api.js';

const Addtowersstep8 = () => {
  const [showExitPopup, setShowExitPopup] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { towerId } = location.state || {}; // Receive towerId from previous steps

  const [broucher, setBroucher] = useState(null);
  const [approvedBy, setApprovedBy] = useState([null]);

  useEffect(() => {
    console.log('🚀 Received towerId in Step 8:', towerId);
  }, [towerId]);

    const storedData = JSON.parse(localStorage.getItem('AdminDetails')) || {};
let managementId = storedData?.data?.data?._id || null;
  const handleBroucherChange = (e) => {
    setBroucher(e.target.files[0]);
  };


  const handleApprovedByChange = (e, idx) => {
    const file = e.target.files[0] || null;
    setApprovedBy(prev => {
      const updated = [...prev];
      updated[idx] = file;
      return updated;
    });
  };

  const handleAddApprovedBy = () => {
    setApprovedBy(prev => [...prev, null]);
  };

  const handleRemoveApprovedBy = (idx) => {
    setApprovedBy(prev => prev.filter((_, i) => i !== idx));
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!broucher || approvedBy.length === 0) {
//       alert('Please upload both broucher and approvedBy images.');
//       return;
//     }
//     const formData = new FormData();
//     formData.append('towerId', towerId);
//     formData.append('updatedBy', managementId);
//     formData.append('broucher', broucher);
//     approvedBy.forEach((file, idx) => {
//       formData.append('approvedBy', file);
//     });

//   try {
//   const response = await api.addTowersStep8(formData, towerId, managementId);
//   console.log(response, '🚀 Response from Step 8 API:');
// } catch (err) {
//   console.error('Submission failed:', err);
//   alert('Submission failed.');
// }
//   };
   const handleSubmit = async (e) => {
  e.preventDefault();

  if (!broucher || approvedBy.filter(Boolean).length === 0) {
    alert('Please upload both broucher and at least one approvedBy image.');
    return;
  }
  const formData = new FormData();
  formData.append('towerId', towerId);
  formData.append('updatedBy', managementId);
  formData.append('brochure', broucher);
  approvedBy.filter(Boolean).forEach((file) => {
    formData.append('approvedBy', file);
  });

  try {
    const response = await api.addTowersStep8(formData);
    console.log(response, '🚀 Response from Step 8 API:');
    navigate('/addtowers/step9', { state: { towerId } });

    // Clear the form after successful submission
    setBroucher(null);
    setApprovedBy([null]);
    // Clear all file input values in the DOM
    const form = document.querySelector('.addtowers-form');
    if (form) {
      const inputs = form.querySelectorAll('input[type="file"]');
      inputs.forEach(input => {
        input.value = null;
      });
    }
     // ✅ Navigate to Step 9 and pass towerId
  navigate('/addtowers/step9', { state: { towerId } });

  } catch (err) {
    console.error('Submission failed:', err);
    alert('Submission failed.');
  }
};
 const handleExit = () => {
          setShowExitPopup(false); // Hide the popup
          navigate('/login/dashboard', { replace: true }); // Navigate to the dashboard
        };

  return (
    <>
      <Dashheader />
      <div className="addtowers">
         <h2>Add Project - Step 8</h2>
        <form onSubmit={handleSubmit} className="addtowers-form">
          <div>
            <label>Broucher (PDF):</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={handleBroucherChange}
              required
            />
            {broucher && <span>{broucher.name}</span>}
          </div>
          <div>
            <label>Approved By (Images):</label>
            {approvedBy.map((file, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => handleApprovedByChange(e, idx)}
                  required={approvedBy.length === 1}
                />
                {file && <span style={{ marginLeft: 8 }}>{file.name}</span>}
                <button
                  type="button"
                  onClick={() => handleRemoveApprovedBy(idx)}
                  disabled={approvedBy.length === 1}
                  style={{ marginLeft: 8 }}
                >
                  Remove
                </button>
              </div>
            ))}
            <button type="button" onClick={handleAddApprovedBy} style={{ marginTop: 8 }}>
              Add Field
            </button>
          </div>
          {/* Optionally, add updatedBy input or set it from context */}
          <button type="submit">Submit</button>
           <button type="button" onClick={() => setShowExitPopup(true)} className="exit-button">Exit</button>
        </form>
          {showExitPopup && ( 
  <div className="exit-popup">
    <p>Are you sure you want to exit ?</p>
    <button onClick={handleExit}>Yes</button>
    <button onClick={() => setShowExitPopup(false)}>No</button>
  </div>
)}
      </div>
    
    </>
  )
}

export default Addtowersstep8